import React, {Fragment, useState} from 'react'
import {Disclosure} from '@headlessui/react'
import {Bars3Icon, GlobeAltIcon, HomeIcon, XMarkIcon} from '@heroicons/react/24/outline'

import {Link, useLocation} from "react-router-dom";
import {useLang} from "../context/lang";


const navigation = [
  { name: 'About',ln:'en', href: 'about', current: false },
  { name: 'CV', ln:'en',href: 'cv', current: false },

  { name: 'Contacts', ln:'en', href: 'contacts', current: true },
  { name: 'Sobre mi',ln:'es', href: 'about', current: false },
  { name: 'CV', ln:'es',href: 'cv', current: false },

  { name: 'Contactos', ln:'es', href: 'contacts', current: true },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Nav() {
  // eslint-disable-next-line no-undef
const loc=useLocation();

  const lang=useLang();
  console.log(lang);
const userf=false;
const auth=false;

  const [log, setLog] = useState('login');
  function opSign(){
    setLog('sign');
  }
  function opLog(){
    setLog('login');
  }


  function setLogd(sign) {
 setLog(sign);
  }

  return  loc.pathname!='//' && (
   <Disclosure as="nav" className="bg-gray-900">
      {({ open }) => (
        <>
        <div className="lg:container lg:mx-auto md:container md:mx-auto sm:p-4">

          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className=" lg:flex md:flex sm:flex hidden flex-1 items-center text-white justify-center sm:items-stretch sm:justify-start">
                <div className="flex flex-shrink-0 items-center px-4">
                  <Link to={'/'}  >     <HomeIcon height={18} width={18}/></Link></div>

                {navigation.filter(a=>a.ln==lang.lang && a).map(a=> (

                  <div key={a.name} className="flex flex-shrink-0 items-center px-4">
             <Link to={'/'+a.href}  className={loc.pathname == '/'+a.href ? 'underline' : ''}>   {a.name}</Link>
                  </div>

                ))}

              </div>
              <div
                className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <button
                  type="button" onClick={() =>lang.setLang(lang.lang == 'en' ? 'es' : 'en')}
                  className="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                >
                  <span className="absolute -inset-1.5"/>


                  <GlobeAltIcon className="h-6 w-6" aria-hidden="true"/>
                </button> <span className="text-white ml-2">{lang.lang == 'en' ? 'ES' : "EN"}</span>
                {/* Profile dropdown */}






              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.filter(a=>a.ln==lang.lang).map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                    'block rounded-md px-3 py-2 text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </div>
        </>
      )}
    </Disclosure>
  )
}
